// @ts-strict-ignore
import Image from 'next/image'
import { CSSProperties, memo } from 'react'

import { SkeletonLoader } from '@/shared/lib/components/SkeletonLoader/SkeletonLoader'

import cl from './bonus-bar.module.scss'

const styles: CSSProperties = { lineHeight: 'unset' }

interface BonusBarProps {
	productId: number
	isLoading: boolean
	bonuses?: number
	isError?: boolean
}

export const BonusBar = memo((props: BonusBarProps) => {
	const { bonuses = null, isError = false, isLoading } = props

	const showNbclubBonuses = bonuses > 0

	if (isLoading) {
		return (
			<div className={cl.root}>
				<SkeletonLoader height={22} width={150} borderRadius={6} style={styles} />
			</div>
		)
	}

	if (isError || !showNbclubBonuses) {
		return null
	}

	return (
		<div className={cl.root}>
			<div className={cl.nbclub}>
				<div className={cl.nbclub__bonusesCount}>
					<div>
						<Image src="/entities/Bonus/bonusLogo.png" width={15} height={15} alt="" />
					</div>
					<span>{bonuses}</span>
				</div>
				<p>бонусов NBclub</p>
			</div>
		</div>
	)
})
